import { deDE } from "./de-DE";
import { enDE } from "./en-DE";
import { svSE } from "./sv-SE";
import { enSE } from "./en-SE";
import { frFR } from "./fr-FR";
import { enFR } from "./en-FR";

export const organizationData = {
  "de-DE": deDE,
  "en-DE": enDE,
  "sv-SE": svSE,
  "en-SE": enSE,
  "fr-FR": frFR,
  "en-FR": enFR,
} as const;

export type OrganizationLocale = keyof typeof organizationData;
